import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { FlowControlService } from '../../../../services/flow-control.service';
import { SnackbarService } from '../../../../services/snackbar.service';
import { RoomsService } from '../../services/rooms.service';

@Component({
  selector: 'app-make-a-booking',
  templateUrl: './make-a-booking.component.html',
  styleUrls: ['./make-a-booking.component.scss'],
})
export class MakeABookingComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private flowControlService: FlowControlService,
    public translate: TranslateService,
    private snackbar: SnackbarService,
    private roomsService: RoomsService
  ) {
    this.flowControlService.updateRouteInfo(
      this.router.url.split('?')[0],
      this.route.snapshot.data
    );
  }
  isLoading = false;

  roomId: string;

  ngOnInit() {
    this.roomId = this.route.snapshot.params.id;
  }
}
